import { useDropzone } from 'react-dropzone';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Button, IconButton, Tooltip } from '@material-ui/core';
import { FileUpload } from './UploadFiles';
import Constant from '@/common/constant/Constant';
import { downloadFileFromS3, getLinkDownloadFileFromS3 } from './FileUploaded';
import OverFlowTooltip from './OverFlowTooltip';
import Utils from '@/common/utils/utils';
import { updatePanelInitData } from '../multiPanel/panel/handler/PanelHandler';
import { cloneDeep } from 'lodash';
import TooltipThumb from './TooltipThumb';
import { I18n } from 'aws-amplify';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { handleOpenTicketDetail, isDisplayHyperLinkFileKnowledge } from '@/component/ticketKnowledge/handler/DetailTicketHandler';

export const EditFileUploaded = ({
    fileUploadList,
    setFileUploadList,
    fileUpdatedList,
    setValue,
    register,
    listFieldEdited,
    ...props
}) => {
    register(props?.name);
    const [publicForCustomer, setPublicForCustomer] = useState(0);
    const [isDisable, setIsDisable] = useState(false);
    const divRef = useRef(null);
    const isUploadForEmailTicket = props.selectTicketType === Constant.HELPDESK_CREATE_TICKET_TYPE.EMAIL || props.ticketType === Constant.TICKET_TYPE.EMAIL;

    useEffect(() => {
        if (props.setShowButtonEditTicket) {
            props.setShowButtonEditTicket();
        }
        
    }, [fileUploadList?.length]);

    useEffect(() => {
        setPublicForCustomer(props.data.structure.publicForCustomer);

        setIsDisable(checkDisableField());
    }, [props.data.structure.publicForCustomer, props.detailTicket])

    const [defaultValue, setDefaultValue] = useState([]);

    const onDrop = useCallback(
        acceptedFiles => {
            handleDragFileOnChange(acceptedFiles);
            return;
        },
        [fileUploadList, listFieldEdited]
    );

    const handleDefaultValueAndCurrentPanelInitData = () => {
        let fileUpdatedListClone = props.currentPanelInitData.fileUpdatedList;
        let listUrlOfFileUpdated = fileUpdatedListClone.map(file => {
            return file.fileUrl
        });

        let listFileOfFieldValue =Utils.isEmptyArray(props?.defaultValue) ? [] : props?.defaultValue
        let listUrlFileOfFieldValue =  listFileOfFieldValue.map(file => {
            return file.fileUrl
        });

        let listFileOfDefaultValue = [];

        fileUpdatedListClone?.forEach((file) => {
            if(listUrlFileOfFieldValue.includes(file.fileUrl)){
                listFileOfDefaultValue.push(file)
            }
        })

        listFileOfFieldValue?.forEach((file) => {
            if(!listUrlOfFileUpdated.includes(file.fileUrl)){
                listFileOfDefaultValue.push(file)
            }
        })

        return listFileOfDefaultValue
    }

    useEffect(() =>{
        if(props.currentPanelInitData && !Utils.isEmptyObject(props.currentPanelInitData)) {
            if (props.currentPanelInitData.fileUploadList) {
                setFileUploadList(props.currentPanelInitData.fileUploadList);
                props?.setShowButtonEditTicket && props?.setShowButtonEditTicket(); 
            }
        }

    }, [])

    const filterDefaultValue = (value) => {
        let newValue = []
        let newFileUploadedList = value.filter(item => !Utils.isImageFile(item.fileName));
        // get list image
        let fileImageList = value.filter(item => Utils.isImageFile(item.fileName));
        newValue = [...newFileUploadedList, ...fileImageList]
        return newValue
    }

    useEffect(() => {
        if (props.ticketType === Constant.TICKET_TYPE.EMAIL_REPLY) return;
        if (!props?.defaultValue || Utils.isEmptyArray(props?.defaultValue) || typeof props?.defaultValue === 'string') {
            setDefaultValue([]);
            props.setFileUpdatedList([]);
            return;
        };

        if(props.currentPanelInitData && !Utils.isEmptyObject(props.currentPanelInitData) && !Utils.isEmptyArray(props.currentPanelInitData.fileUpdatedList)) {
            let defaultValueData = handleDefaultValueAndCurrentPanelInitData();

            // Update HyperlinkIcon FileKnowledge when existed
            defaultValueData = defaultValueData.map(valueData => {
                let updateValueData = {...valueData}
                if (valueData.isPdf) {
                    for (let i = 0; i < props?.defaultValue?.length; i++) {
                        const newValueData = props?.defaultValue[i];
                        if (newValueData.fileUrl === updateValueData.fileUrl && newValueData.idTicketFileKnowledge) {
                            updateValueData = {...newValueData}
                        }
                    }
                }
                return updateValueData
            })

            setDefaultValue(filterDefaultValue(defaultValueData));
            props.setFileUpdatedList(defaultValueData);
        } else {
            setDefaultValue(filterDefaultValue([...props?.defaultValue]));
            props.setFileUpdatedList([...props?.defaultValue]);
            updatePanelInitData(props.panelId, props.tabId, props.panelInitData, props.setPanelInitData, 'fileUpdatedList', [...props?.defaultValue]);
        }
        
        if (!Utils.isEmptyArray(...props?.defaultValue)) {
            setValue(props?.name, 'fileUploaded');
            props.clearErrors(props?.name);
        } else {
            setValue(props?.name, '');
        }
    }, [props?.defaultValue]);

    useEffect(() => {
        if (props.ticketType === Constant.TICKET_TYPE.EMAIL_REPLY) return;
        if ((!Utils.isEmptyArray(fileUploadList) || !Utils.isEmptyArray(props?.defaultValue)) && isUploadForEmailTicket && props.setErrorCreateTicket) {
            let totalFileSize = 0;
            fileUploadList.forEach(file => {
                if (file?.file?.size) {
                    totalFileSize += parseInt(file?.file?.size);
                }
            })
            let defaultValueFile = props?.defaultValue;
            if (!Utils.isEmptyArray(defaultValueFile)) {
                defaultValueFile.forEach(file => {
                    if (file?.fileSize) {
                        totalFileSize += parseInt(file?.fileSize);
                    }
                })
            }

            if (totalFileSize) {
                let convertTotalFileSizeToMB = Utils.convertByteToMB(totalFileSize)
                if (convertTotalFileSizeToMB > Constant.LIMIT_VALUE_VALIDATE.MB_FILE_UPLOAD_FOR_EMAIL_TICKET) {
                    props.setErrorCreateTicket(
                        props?.name,
                        { type: 'manual', message: I18n.get('MGS-FILE-OVER-CAPACITY').replace('{{fileSize}}', Constant.LIMIT_VALUE_VALIDATE.MB_FILE_UPLOAD_FOR_EMAIL_TICKET) },
                        { shouldFocus: true }
                    );
                }
            } else {
                props.clearErrors(props?.name); 
            }
        } else {
            props.clearErrors(props?.name);
        }
    }, [fileUploadList, props?.defaultValue]);

    // uef to ONLY EMAIL_REPLY (because: too many re-render if use common's uef)
    useEffect(() => {
        if (props.ticketType !== Constant.TICKET_TYPE.EMAIL_REPLY) return;

        setDefaultValue(filterDefaultValue([...props?.defaultValue]));
        props.setFileUpdatedList([...props?.defaultValue]);
        updatePanelInitData(props.panelId, props.tabId, props.panelInitData, props.setPanelInitData, 'fileUpdatedList', [...props?.defaultValue]);
    }, [props?.isTriggerReloadCurrentTicket])

    const { getRootProps, getInputProps } = useDropzone({ onDrop, disabled: isDisable });

    const handleDragFileOnChange = fileList => {
        let tempFileUploadList = [];
        const structureForm = Utils.convertJSONDataToObject(props.parentForm?.structure);

        for (let i = 0; i < fileList.length; i++) {
            if (fileList[i]) {
                const type = fileList[i].type;
                let fileUpload = {
                    file: fileList[i],
                    progress: 0,
                    status: true,
                    key: '',
                    splitPdf: structureForm?.splitPdf ? true : false,
                    isExpand: true,
                    isPdf: type === 'application/pdf'
                };
                tempFileUploadList.push(fileUpload);
            }

            let newFileUploadList = [...fileUploadList, ...tempFileUploadList];

            if (props?.setIsEdited) {
                if(props?.setOnChangeEdit){
                    if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
                }
                props?.setIsEdited(true);
                let newFieldEdited = listFieldEdited?.filter(id => {
                    return id !== 'attachment' && id !== 'suffixOfAttachments';
                });
                newFieldEdited = Utils.isEmptyArray(newFieldEdited) ? [] : newFieldEdited;
                props?.setListFieldEdited([...newFieldEdited, 'attachment', 'suffixOfAttachments']);
            }
            
            setFileUploadList(newFileUploadList);
            setValue(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, newFileUploadList);

            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket();
            if(!Utils.isEmptyArray(tempFileUploadList)) {
                setValue(props?.name, 'fileUploaded');
                props.clearErrors(props?.name);
            } else {
                setValue(props?.name, '');
            }
        }
    };

    const handleDeleteFile = index => {
        let newFileUploadList = cloneDeep(fileUploadList);
        if (newFileUploadList[index]) {
            newFileUploadList.splice(index, 1);
        }

        if (props?.setIsEdited) {
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
            props?.setIsEdited(true);
            let newFieldEdited = listFieldEdited?.filter(id => {
                return id !== 'attachment' && id !== 'suffixOfAttachments';
            });
            newFieldEdited = Utils.isEmptyArray(newFieldEdited) ? [] : newFieldEdited;
            props?.setListFieldEdited([...newFieldEdited, 'attachment', 'suffixOfAttachments']);
        }

        setValue(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, newFileUploadList);
        setFileUploadList([...newFileUploadList]);
        props?.setShowButtonEditTicket && props?.setShowButtonEditTicket();
        if(!Utils.isEmptyArray(newFileUploadList)) {
            setValue(props?.name, 'fileUploaded');
            props.clearErrors(props?.name);
        } else {
            setValue(props?.name, '');
        }
    };
    
    const checkDisableField = () => {
        return (
            props?.data?.structure?.publicForCustomer === 2 ||
            props?.hasEditFieldPermissions === false ||
            !Utils.isEmptyString(props?.detailTicket?.deletedAt) ||
            props?.detailTicket?.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED ||
            props?.isDisableEdit === true
        )
    }

    const isDisplayConvertPDFEditFunction = (isPdf = false) => {
        const isServicesPDFOfCorpOn = props.detailTicket?.convertPDFOrg === 1 ? true : false;
        const commonCondition = Utils.isEmptyString(props.detailTicket?.deletedAt) && props?.isDisplaySplitPdfSwitch && isPdf && isServicesPDFOfCorpOn;
    
        if(props.detailTicket?.public !== Constant.TICKET_PUBLIC.DRAFT) {
            return props.hasEditFieldPermissions === true && commonCondition;
        }
        return commonCondition;
    }

    const onChangePdf = (index) => {
        props.setIsEdited(true);
        setFileUploadList(prev => {
            const prevClone = cloneDeep(prev);
            prevClone[index].splitPdf = !prev[index].splitPdf;
            setValue(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, prevClone);
            return prevClone;
        })
    }

    const onChangePdfFileUploaded = (index) => {
        props.setIsEdited(true);
        setDefaultValue(prev => {
            const prevClone = cloneDeep(prev);
            prevClone[index].splitPdf = !prev[index].splitPdf;
            if(!prev[index]?.isPdf) prevClone[index].isPdf = Utils.isNameOrUrlOfPdfFile(prev[index]?.fileName)
            return prevClone;
        })
        
        props.setFileUpdatedList(prev => {
            const prevClone = cloneDeep(prev);
            prevClone[index].splitPdf = !prev[index].splitPdf;
            if(!prev[index]?.isPdf) prevClone[index].isPdf = Utils.isNameOrUrlOfPdfFile(prev[index]?.fileName)
            return prevClone;
        })
    }

    const onClickToggleExpandedPdf = (index) => {
        setFileUploadList(prev => {
            const prevClone = cloneDeep(prev);
            prevClone[index].isExpand = !prev[index].isExpand;
            return prevClone;
        })
    }

    const onClickToggleFileUploadedExpandedPdf = (index) => {
        setDefaultValue(prev => {
            const prevClone = cloneDeep(prev);
            prevClone[index].isExpand = !prev[index].isExpand;
            return prevClone;
        })
        // props.setFileUpdatedList(prev => {
        //     const prevClone = cloneDeep(prev);
        //     prevClone[index].isExpand = !prev[index].isExpand;
        //     return prevClone;
        // })
    }

    const renderFiledUpload = () => {
                let contentChatList = [];
        if (Utils.isEmptyString(props.detailTicket?.deletedAt)) {
            fileUploadList.forEach((fileUploadInfor, index) => {
                const isPdf = fileUploadInfor.isPdf;
                const splitPdf = fileUploadInfor.splitPdf;
                let item = { content: fileUploadInfor.file.name, fileSize: fileUploadInfor.file.size };
                contentChatList.push(
                    <>
                        <li>
                            <FileUpload
                                key={index}
                                fileUploadInfor={fileUploadInfor}
                                fileUploading={props.fileUploading}
                                chatPost={item}
                                isPdf={isPdf}
                                onClickToggleExpandedPdf={() => onClickToggleExpandedPdf(index)}
                                isDisplaySplitPdfSwitch={props?.isDisplaySplitPdfSwitch}
                            ></FileUpload>
                            <div className="lstName-item">
                                <IconButton
                                    disabled={checkDisableField()}
                                    onClick={() => handleDeleteFile(index)}
                                    className="itemDelete"
                                >
                                    <img src="/assets/image/dustbox_b.png" alt="" />
                                </IconButton>
                            </div>
                        </li>
            
                        {isPdf && props?.isDisplaySplitPdfSwitch && (
                            <>
                                <div
                                    className={`setting-item-group ${!fileUploadInfor?.isExpand && 'setting-item-group-none'}`}
                                    key={index}
                                >
                                    <div className="setting-children-item setting-pdf-file-item">
                                        <label className="setting-label">{I18n.get("LABEL-SPLIT-PDF-INTO-PAGES")}</label>
                                        <div className="switch-check">
                                            <input
                                                type="checkbox"
                                                id={`switch-pdf-mode-${index}`}
                                                checked={splitPdf}
                                                onChange={() => onChangePdf(index)}
                                                disabled={checkDisableField()}
                                            />
                                            <label htmlFor={`switch-pdf-mode-${index}`}></label>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                );
            });
        }
        return contentChatList;
    };

    const formatBytes = (bytes, decimals = 2) => {
        if (!+bytes) return '0 B'
    
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    
        const i = Math.floor(Math.log(bytes) / Math.log(k))
    
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }


    const deleteFile = index => {
        let defaultValueTmp = cloneDeep(defaultValue);
        if (defaultValueTmp[index]) {
            defaultValueTmp.splice(index, 1);
        }
        if (props?.setIsEdited) {
            if(props?.setOnChangeEdit){
                    props?.setOnChangeEdit(!props.onChangeEdit)
                }
            props?.setIsEdited(true);
            props?.setShowButtonEditTicket && props?.setShowButtonEditTicket();
            let newFieldEdited = listFieldEdited?.filter(id => {
                return id !== 'attachment' && id !== 'suffixOfAttachments';
            });
            newFieldEdited = Utils.isEmptyArray(newFieldEdited) ? [] : newFieldEdited;
            props?.setListFieldEdited([...newFieldEdited, 'attachment', 'suffixOfAttachments']);
        }
        const fileDeletedList = defaultValue[index];
        if (props?.setFileDeletedList) {
            props?.setFileDeletedList(prev => [...prev, {...fileDeletedList, isDelete: true}])
        }
        setDefaultValue([...defaultValueTmp]);
        if(!Utils.isEmptyArray(fileUpdatedList)){
            let fileUpdatedListClone = fileUpdatedList?.filter((file => file.isDelete));
            fileUpdatedListClone.push({ ...fileDeletedList, isDelete: true });
            props.setFileUpdatedList([...defaultValueTmp, ...fileUpdatedListClone]);
        }else{
            props.setFileUpdatedList([...defaultValueTmp, { ...fileDeletedList, isDelete: true }]);
        }
    };

    const isDisplayBoxUploadFile = () => {
        if (!Utils.isEmpty(props.addTicket)) {
            return true;
        }
        
        if (props.componentName === Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE) {
            return props?.hasEditFieldPermissions;
        }

        return publicForCustomer === Constant.SETTING_PUBLIC_FOR_CUSTOMER.EDITABLE;
    }

    const renderFileImageUpload = (fileImageList, imageLength) => {
        let fileImageComponentList = [];
        fileImageList?.forEach((item,index) => {
            fileImageComponentList.push(
                <li className="justify-content-center">
                    <div className="display-thumb">
                        <div className="class-relative cursor-default listmap-item">
                            {!checkDisableField() && (
                                <div className="lstName-item class-image hover-dblock">
                                    <div
                                        className="delete-image"
                                        onClick={() => deleteFile(index + imageLength)}
                                    >
                                        <img src="/assets/image/icon-closeUpfile.svg" alt="" />
                                    </div>
                                </div>
                            )}
                            <TooltipThumb
                                value={`${item.fileName}(${formatBytes(item.fileSize)})`}
                                className="titleDisplay"
                            >
                                <img
                                    // className="cursor-default"
                                    style={{
                                        maxHeight: `${divRef.current.offsetWidth}px`,
                                    }}
                                    src={
                                        Utils.isImageFile(item.fileName)
                                            ? getLinkDownloadFileFromS3(
                                                    { ...item, type: 1 },
                                                    props.detailTicket,
                                                    null,
                                                    Constant.ATTACH_FILE.VIEW_TICKET_DETAIL
                                                )
                                            : '/assets/image/others_file.png'
                                    }
                                    alt=""
                                    aria-label="more"
                                    aria-controls="long-menu"
                                    aria-haspopup="true"
                                    onClick={e => {
                                        downloadFileFromS3(
                                            { type: 1, ...item },
                                            props.detailTicket,
                                            false, false, '', props?.setIsShowPopupLogout
                                        );
                                    }}
                                />
                            </TooltipThumb>
                        </div>
                        <div
                            className="text-truncate text-center cursor-default"
                            style={{
                                maxWidth: `${divRef.current.offsetWidth}px`
                            }}
                        >
                            {`${item.fileName}(${formatBytes(item.fileSize)})`}
                        </div>
                    </div>
                </li>
            );
        })
        return fileImageComponentList;
    }

    const renderFileUploaded = fileUploadedList => {
        let newFileUploadedList = fileUploadedList.filter(item => !Utils.isImageFile(item.fileName));
        newFileUploadedList = newFileUploadedList.filter((file) => !file.isDelete )

        // get list image
        let fileImageList = fileUploadedList.filter(item => Utils.isImageFile(item.fileName));
        fileImageList = fileImageList.filter((file) => !file.isDelete )
        let fileNotImageLength = newFileUploadedList.length;
        let fileUploadedComponentList = [];

        newFileUploadedList?.forEach((file,index) => {
            let isPdf = file.isPdf ? file.isPdf : Utils.isNameOrUrlOfPdfFile(file?.fileName);
            let splitPdf = file?.splitPdf ? file.splitPdf : false;    

            let defaultFileData = {};
            if (props.defaultValue && !Utils.isEmptyArray(props.defaultValue)) {
                defaultFileData = props.defaultValue.find(fileDefault => fileDefault.fileUrl === file.fileUrl)
            }
            let defaultSplitPdf = defaultFileData?.splitPdf ? defaultFileData?.splitPdf : false;
            
            fileUploadedComponentList.push(
                <>
                    <li>
                        {isDisplayConvertPDFEditFunction(isPdf) && (
                            <ArrowDropDownIcon
                                onClick={() => onClickToggleFileUploadedExpandedPdf(index)}
                                className={`${
                                    isDisplayConvertPDFEditFunction(isPdf)
                                        ? file?.isExpand
                                            ? 'icon-pdf-expand'
                                            : 'icon-pdf-collapse'
                                        : 'icon-pdf-collapse'
                                }`}
                            />
                        )}
                        {(
                            <a
                                className="file-upload-name--change file-upload-active"
                                target="_blank"
                                onClick={e => {
                                    downloadFileFromS3({ type: 1, ...file }, props.detailTicket, false, false, '', props?.setIsShowPopupLogout);
                                }}
                            >
                                <OverFlowTooltip
                                    value={`${file.fileName}(${formatBytes(file.fileSize)})`}
                                    className={'link-file-name'}
                                ></OverFlowTooltip>
                            </a>
                        )}
                        {
                            !checkDisableField() &&
                            (
                            <div className="lstName-item">
                                <IconButton
                                    disabled={checkDisableField()}
                                    onClick={() => deleteFile(index)}
                                    className="itemDelete"
                                >
                                    <img src="/assets/image/icon-closeUpfile.svg" alt="" />
                                </IconButton>
                            </div>
                            )
                        }

                        {/* Link FileKnowledgeDetail */}
                        {isDisplayHyperLinkFileKnowledge(
                            file,
                            props.detailTicket?.convertPDFOrg
                        ) && (
                            <Tooltip
                                title={I18n.get('ファイルナレッジを表示')}
                                aria-label={I18n.get('ファイルナレッジを表示')}
                            >
                                <div
                                    className="file-knowledge-ticket-link"
                                    onClick={() =>
                                        handleOpenTicketDetail(
                                            file.idTicketFileKnowledge,
                                            Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE,
                                            '',
                                            '',
                                            props?.setIsLoading,
                                            props?.currentUserDetail,
                                            props?.projectInuseDetail,
                                            props?.setIsOpenAccessDeniedPopup,
                                            props?.addNewPanel,
                                            props?.panelId,
                                            props?.isCustomer
                                        )
                                    }
                                >
                                    <img src="/assets/image/icon-show-file-knowledge.svg" alt="" />
                                </div>
                            </Tooltip>
                        )}
                    </li>
                    {isDisplayConvertPDFEditFunction(isPdf) && (
                        <div
                            className={`setting-item-group ${!file?.isExpand &&
                                'setting-item-group-none'}`}
                            key={index}
                        >
                            <div className="setting-children-item setting-pdf-file-item">
                                <label className="setting-label">
                                    {I18n.get('LABEL-SPLIT-PDF-INTO-PAGES')}
                                </label>
                                <div className="switch-check">
                                    <input
                                        type="checkbox"
                                        id={`file-uploaded-switch-pdf-mode-${index}`}
                                        checked={splitPdf}
                                        onChange={() => onChangePdfFileUploaded(index)}
                                        disabled={checkDisableField() || defaultSplitPdf}
                                    />
                                    <label
                                        htmlFor={`file-uploaded-switch-pdf-mode-${index}`}
                                    ></label>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            );
        });
        let fileImageComponentList = renderFileImageUpload(fileImageList, fileNotImageLength)
        if (fileImageComponentList.length > 0) {
            fileUploadedComponentList = [...fileUploadedComponentList, ...fileImageComponentList];
        }
        return fileUploadedComponentList;
    };
    
    const isCustomerHasFileUpload = (fileUploadedList) => {
        if (!Utils.isEmpty(props.addTicket)) {
            return false;
        }

        return props.componentName !== Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE && 
        publicForCustomer !== Constant.SETTING_PUBLIC_FOR_CUSTOMER.EDITABLE && 
        fileUploadedList.length <= 0
    }

    const isCustomerKnowledgeHasFileUpload = (fileUploadedList) => {
        if (!Utils.isEmpty(props.addTicket)) {
            return false;
        }

        return props.componentName === Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE && 
        !props?.hasEditFieldPermissions && 
        fileUploadedList.length <= 0
    }

    const renderLabel = fileUploadedList => {
        if (
            isCustomerHasFileUpload(fileUploadedList) ||
            isCustomerKnowledgeHasFileUpload(fileUploadedList)
        ) {
            return '';
        }

        return (
            <div className="cell-prod-status gap-8">
                {props?.isTooltipTitle ? (
                    <div className="d-flex">
                        <Tooltip title={props?.label}>
                            <span className="form-addTicket-label text-truncate">
                                <label
                                    className={
                                        'text-truncate line-height-18' +
                                        (publicForCustomer
                                            ? 'form-addTicket-label-color'
                                            : 'form-addTicket-label')
                                    }
                                >
                                    {props?.label}
                                </label>
                            </span>
                        </Tooltip>
                        {props.data.structure.required && (
                            <span className="required padding-left-4">*</span>
                        )}
                    </div>
                ) : (
                    <label
                        className={
                            publicForCustomer
                                ? 'form-addTicket-label-color'
                                : 'form-addTicket-label'
                        }
                    >
                        {props?.label}
                        {props.data.structure.required && <span className="required">*</span>}
                    </label>
                )}
                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement='top' arrow >
                        <img
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
            </div>
        );
    };


    const preventOpenNewTab = (e) => {
        if (isDisable) {
            e.nativeEvent.preventDefault();
            if (!e) return;
        }
    }

    const preventDraggingOpenNewTab = {
        onDrop: e => preventOpenNewTab(e)
    }

    const isEmptyUploadFile = () => {
        if (!props.data.structure.required) return false;
        if (!Utils.isEmptyArray(fileUploadList)) return false;
        let isEmptyAfterEdit = false;
        if (!Utils.isEmptyArray(fileUpdatedList)) {
            let listNotDelete = fileUpdatedList.filter(file => !file.isDelete);
            if (Utils.isEmptyArray(listNotDelete)) {
                isEmptyAfterEdit = true;
            }
        }
        
        return !props.isDuplicate && isEmptyAfterEdit;
    }

    return (
        <div className="form-addTicket">
            {renderLabel(defaultValue)}
            <div className="form-addTicket-input" ref={divRef}>
                    <div className="lstName-file">
                        <ul>{renderFiledUpload()}</ul>
                        <ul>{!props.isDuplicate && renderFileUploaded(defaultValue)}</ul>
                    </div>

                {isDisplayBoxUploadFile() && (<div
                    className="formUpload"
                    {...getRootProps()}
                    {...(isDisable ? preventDraggingOpenNewTab : {})}
                    data-cy="drop-file-input-upload"
                >
                    <input disabled={isDisable} {...getInputProps()} />
                    <label htmlFor="contained-button-file">
                        <Button disabled={isDisable} variant="contained" component="span">
                            <div className="formUpload-item">
                                <img src="/assets/image/icon-upload.svg" alt="" />
                                <span
                                    className={`${
                                        isDisable ? 'fields-disabled' : ''
                                    } formUpload-txt`}
                                >
                                    {I18n.get('MSG-DRAG-DROP-FILE')}
                                </span>
                            </div>
                        </Button>
                    </label>
                </div>)}
                {props?.errorlist && props.errorlist[props.name]?.message && (
                    <div className="upload-file-error 1111">
                        {props.errorlist[props.name]?.message}
                    </div>
                )}
                
                {props.attachmentError && !Utils.isEmptyString(props.attachmentError) && (
                    <div className="upload-file-error pt-3">
                        {props.attachmentError}
                    </div>
                )}

                {
                    isEmptyUploadFile() && 
                    <div className="upload-file-error pt-3">
                        {`入力形式に誤りがあります`}
                    </div>
                }
            </div>
        </div>
    );
};
